export const typesRepository = {
    createRepository: '[Repository] create Repository',
    getRepository: '[Repository] get Repository',
    deleteRepository: '[Repository] delete Repository',
    updateRepository: '[Repository] update Repository',
    uploadProgressMaterial: '[Repository] upload progress Repository',
    clearUploadProgressMaterial: '[Repository] clear upload progress Repository',
    setCancelToken: '[Repository] set cancel token',
}
